import { Button } from "components/Button/Button";
import { Markdown } from "components/Form/components/Markdown/Markdown";
import { IconCollection } from "components/Icon/IconCollection";
import { ReactNode, useRef, useState } from "react";
import "./ExpandableNotification.scss";
import SimpleNotification, { StandardNotificationProps } from "./SimpleNotification";

type ExpandableNotificationProps = StandardNotificationProps & {
    details?: ReactNode;
    detailsForClipboard?: string;
    alwaysExpanded?: boolean;
};

export default ({
    title,
    subtitle,
    details,
    detailsForClipboard,
    alwaysExpanded,
}: ExpandableNotificationProps) => {
    const [isExpanded, setExpanded] = useState(alwaysExpanded ?? false);
    const textRef = useRef<HTMLDivElement>(null);

    const selectAllText = () => {
        if (textRef.current) {
            const range = document.createRange();
            const selection = window.getSelection();

            range.selectNodeContents(textRef.current);
            selection?.removeAllRanges();
            selection?.addRange(range);
        }
    };

    const [isCopied, setCopied] = useState(false);

    const ExpandButton = ({ isExpanded }: { isExpanded: boolean }) => (
        <div className="showMore">
            <Button
                icon={isExpanded ? IconCollection.chevronUp : IconCollection.chevronDown}
                onClick={() => setExpanded(!isExpanded)}
                label={isExpanded ? "Show less" : "Show more"}
                variation="white"
                size="small"
            />
        </div>
    );
    const simpleNotification = (
        <>
            <div className="simpleNotificationContainer">
                <SimpleNotification title={title} subtitle={subtitle} />
                <Button
                    className="copyButton"
                    label="Copy to clipboard"
                    labelOnlyAria
                    size="small"
                    icon={isCopied ? IconCollection.check : IconCollection.contentCopy}
                    onClick={() => {
                        selectAllText();
                        setCopied(true);
                        navigator.clipboard.writeText(textToCopy);
                        setTimeout(() => {
                            setCopied(false);
                            window.getSelection()?.removeAllRanges();
                        }, 300);
                    }}
                />
            </div>
            {details && !alwaysExpanded && <ExpandButton isExpanded={isExpanded} />}
        </>
    );
    const detailsToCopy = detailsForClipboard ?? (typeof details === "string" ? details : "");
    const textToCopy = `${title ? `${title}\n` : ""}${subtitle ? `${subtitle}\n` : ""}${
        detailsToCopy || ""
    }`;
    return (
        <div className="expandableNotification" ref={textRef}>
            {details ? (
                <div className="expandableContainer">
                    {simpleNotification}

                    <div className={`expandedContent ${isExpanded ? "expandedContentShown" : ""}`}>
                        {typeof details === "string" ? (
                            <Markdown markdownString={details} className="details" />
                        ) : (
                            <div className="details">{details}</div>
                        )}
                    </div>
                </div>
            ) : (
                simpleNotification
            )}
        </div>
    );
};
